import { Slice } from "store/utils/slice";
import type { Organization } from "@superblocksteam/shared";
import type { EntitiesStateWithMeta } from "store/utils/types";

export type OrganizationMeta = {
  userId?: string;
};

type OrganizationState = EntitiesStateWithMeta<Organization, OrganizationMeta>;

export default new Slice<OrganizationState>("organizations", {
  entities: {},
  loading: {},
  errors: {},
  meta: {},
});
